import EditTableModal from './EditTableModal';

export default EditTableModal;
